import { Expose } from "class-transformer";

export class UpdateClientTypeDto {
  @Expose()
  name: string;

  @Expose()
  id: string;

  @Expose()
  isInternal: boolean;
}
